export default {
  methods: {
    group(value) {
      let prepared = [];
      value.forEach(pc => {
        let group = prepared.find(group => group.id === pc.parent.name);
        if(group === undefined) {
          group = {
            id: pc.parent.name,
            code: pc.parent.name,
            name: pc.parent.name,
            children: []
          }
          prepared.push(group)
        }
        if (prepared.find(g => g.children.find(pci => pci.name === pc.name) !== undefined) === undefined) {
          group.children.push(pc);
        }
      })
      return prepared;
    }
  }
}
